import ApplicationController from './application_controller'

// Important: this controller does not work inside of Bootstrap modals, nor does the autofocus attribute!
// This controller should really only be used with Turbo Streams (Turbo Frames should support the autofocus attribute).

export default class extends ApplicationController {
	connect() {
		this.element.focus()
	}
}
